import { Navigate, useSearchParams } from "react-router-dom";


function RedirectWithQuery({ to }: { to: string }) {
    const [searchParams] = useSearchParams();
    return <Navigate to={`${to}?${searchParams.toString()}`} replace />;
};

export default RedirectWithQuery;